import Web3 from 'web3';
import BN from 'bn.js';
import { addresses, swapBO } from './constants';
import Coinracer from "./contracts/Coinracer";
import CoinracerNFT from "./contracts/CoinracerNFT";
import CoinracerMarketPlace from "./contracts/CoinracerMarketPlace";
import axios from "axios";

import Contract from './contracts/Contract';
import CoinracerNFT_mint from "./contracts/CoinracerNFT_mint";
import CoinracerToken_mint from "./contracts/CoinracerToken";
import BusdToken from "./contracts/BusdToken";
import { NumToBN } from './utils';



import CoinracerNFTOld from './contracts/CoinracerNFTOld';
import Toxic from "./contracts/Toxic";
import Mutant from "./contracts/Mutant";


export default class Web3Wrapper {


  web3: Web3;
  chainId: number;
  account: string;
  wrapperOptions: any;

  // Contracts
  coinRacerNFTFactory: CoinracerNFT;
  coinRacerMarketPlace: CoinracerMarketPlace;
  coinRacerToken: Coinracer;

  // Contracts
  coinracerNFT: CoinracerNFT_mint;
  coinracerNFTOld: CoinracerNFTOld;
  coinracerToken_mint: CoinracerToken_mint;
  busdToken: BusdToken;

  toxic: Toxic;
  mutant: Mutant;

  constructor(web3, chainId, account, options = {}) {
    this.web3 = web3;
    this.chainId = chainId;
    this.account = account;

    this.wrapperOptions = {
      web3, chainId, account,
      ...options
    }

    this.coinRacerNFTFactory = new CoinracerNFT(this.wrapperOptions, addresses.coinracerNFT[this.chainId]);
    this.coinRacerMarketPlace = new CoinracerMarketPlace(this.wrapperOptions, addresses.coinracerMarketPlace[this.chainId]);
    this.coinRacerToken = new Coinracer(this.wrapperOptions, addresses.coinracerToken[this.chainId]);

    console.log("chainid =======> ", this.chainId);
    this.coinracerNFT = new CoinracerNFT_mint(this.wrapperOptions, addresses.coinracerNFT[this.chainId]);
    this.coinracerToken_mint = new CoinracerToken_mint(this.wrapperOptions, addresses.coinracerToken[this.chainId]);
    this.busdToken = new BusdToken(this.wrapperOptions, addresses.busdToken[this.chainId]);


    //this.coinracerNFT = new CoinracerNFT(this.wrapperOptions, addresses.coinracerNFT[this.chainId]);
    this.coinracerNFTOld = new CoinracerNFTOld(this.wrapperOptions, addresses.coinracerNFTOld[this.chainId]);
    this.toxic = new Toxic(this.wrapperOptions, addresses.toxic[this.chainId]);
    this.mutant = new Mutant(this.wrapperOptions, addresses.mutant[this.chainId]);
  }


  async getBalanceofCoin(address) {
    const balance: string | any = await this.coinRacerToken.call("balanceOf", address);
    return balance;
  }


  async getInfo(address) {
    const balance: string | any = await this.coinRacerNFTFactory.call("balanceOf", address);
    const bal = parseInt(balance);
    let data: any = [];
    const get_collection_url = "https://marketplace.coinracer.io:2053/getCollection";
    for (let index = 0; index < bal; index++) {
      const tokenIDString: any = await this.coinRacerNFTFactory.call("tokenOfOwnerByIndex", address, index);
      const tokenID = parseInt(tokenIDString);
      const tokenURILoc = await this.coinRacerNFTFactory.call("tokenURI", tokenID);
      const pools_list_url: any = tokenURILoc;
      let tokenURI: any = "";
      let tokenName: any = "";
      let tokenDescription: any = "";
      let saleDeadLine: any = "";
      let initialPrice: number = 0;
      let topBidAddr: any = "";
      let topBidPrice: number = 0;
      let level: number = 1;
      let saleCreated: any = "";
      let isOnSale: number = 1;
      await axios.get(get_collection_url, { params: { id: tokenID } }).then((response) => {
        if (response.data[0]) {
          saleDeadLine = response.data[0]["saleDeadLine"];
          initialPrice = response.data[0]["initialPrice"];
          topBidAddr = response.data[0]["topBidAddr"];
          topBidPrice = response.data[0]["topBidPrice"];
          tokenDescription = response.data[0]["description"];
          // tokenName = response.data[0]["nftName"];
          level = response.data[0]["level"];
          saleCreated = response.data[0]["saleCreated"];
          isOnSale = response.data[0]["isOnSale"];
        }
        else console.log("");
      });
      await axios.get(pools_list_url).then((response) => {
        tokenName = response.data["name"];
        // tokenDescription = response.data["description"];
        tokenURI = "https://ipfs.io/ipfs/" + response.data["image"].slice(7, response.data["image"].length);
        let temp = {
          "tokenID": tokenID,
          "owner": address,
          "tokenURI": tokenURI,
          "name": tokenName,
          "description": tokenDescription,
          "saleDeadLine": saleDeadLine,
          "initialPrice": initialPrice,
          "topBidAddr": topBidAddr,
          "topBidPrice": topBidPrice,
          "level": level,
          "saleCreated": saleCreated,
          "isOnSale": isOnSale
        };
        data.push(temp);
      });
    }
    return data;
  }
  async placeAuction(name, tokenid, owner, uri, timeStamp, price, level, description, createdTime, date) {
    const placeAuctionFunc_url = "https://marketplace.coinracer.io:2053/placeAuction";
    let data;
    // let utcDeadline  = new Date(date).toLocaleString("en-US", {timeZone: "Europe/London"});
    try {
      await this.coinRacerNFTFactory.send("approve", {}, addresses.coinracerMarketPlace[this.chainId], tokenid);
      const priceAmount = Web3.utils.toWei(Web3.utils.toBN(price), "ether");
      await this.coinRacerMarketPlace.send("createAuction", {}, tokenid, priceAmount, timeStamp);
      await axios.get(placeAuctionFunc_url,
        {
          params: {
            name: name,
            tokenid: tokenid,
            owner: owner,
            uri: uri,
            date: date,
            price: price,
            level: level,
            description: description,
            createdTime: createdTime
          }
        }).then((response) => {
          if (response.data[0]) {
            return 1;
          }
          else return 1;
        });
      data = 1;
    } catch (error) {
      console.error(error);
      data = 0;
    }
    return data;
  }

  async placeBid(account, bidAmount, tokenID, currentBid) {
    let date = new Date().toLocaleString("en-US", { timeZone: "Europe/London" });
    const placeBid_url = "https://marketplace.coinracer.io:2053/placeBid";
    try {
      const priceAmount = Web3.utils.toWei(Web3.utils.toBN(bidAmount), "ether");
      await this.coinRacerToken.send("approve", {}, addresses.coinracerMarketPlace[this.chainId], priceAmount);
      await this.coinRacerMarketPlace.send("bid", {}, tokenID, priceAmount);
      await axios.get(placeBid_url,
        {
          params: {
            tokenid: tokenID,
            bidder: account,
            bidAmount: bidAmount,
            date: date
          }
        }).then((response) => {
          if (response.data[0]) {
            return response.data[0];
          }
          else console.log("");
        });
    } catch (error) {
      console.error(error);
    }
  }

  async auction_list_url() {
    const getAuctionList_url = "https://marketplace.coinracer.io:2053/getAuctionList";
    await axios.get(getAuctionList_url).then((response) => {
      if (response.data.length) {
      }
      else console.log("");
    });
  }

  async setSaleStateFalse(tokenid) {
    const setSaleState_url = "https://marketplace.coinracer.io:2053/setSaleStateFalse";
    await axios.get(setSaleState_url,
      {
        params: {
          tokenid: tokenid
        }
      }).then((response) => {
        if (response.data[0]) {
        }
        else console.log("");
      });
  }

  async getBidList(tokenID) {
    const getBidList_url = "https://marketplace.coinracer.io:2053/getBidList";
    const { data } = await axios.get(getBidList_url,
      {
        params: {
          tokenid: tokenID
        }
      })
    return data;
  }

  async getAuctionInfo(tokenID) {
    let auctionInfo: any = await this.coinRacerMarketPlace.call("auctionList", tokenID);
    let bidedAmount: any = await this.coinRacerMarketPlace.call("bidders", tokenID, this.account);
    let isTimeOut: any = await this.coinRacerMarketPlace.call("isTimePassed", tokenID);
    let result = {
      currentPrice: auctionInfo.currentBidPrice,
      currentBidder: auctionInfo.currentBidOwner,
      bidedAmount: bidedAmount,
      bidCount: auctionInfo.bidCount,
      isOpen: auctionInfo.isOpen,
      isTimeOut: isTimeOut
    }
    return result;
  }

  async claimNFT(tokenID) {
    const claimNFT_url = "https://marketplace.coinracer.io:2053/claimNFT";
    try {
      await this.coinRacerMarketPlace.send("claimNFT", {}, tokenID);
      await axios.get(claimNFT_url,
        {
          params: {
            tokenid: tokenID
          }
        }).then((response) => {
          if (response.data[0]) {
          }
          else console.log("");
        });
    } catch (error) {
      console.error(error);
    }
  }

  async claimToken(tokenID) {
    const claimToken_url = "https://marketplace.coinracer.io:2053/claimToken";
    try {
      await this.coinRacerMarketPlace.send("claimToken", {}, tokenID);
      await axios.get(claimToken_url,
        {
          params: {
            tokenid: tokenID
          }
        }).then((response) => {
          if (response.data[0]) {
          }
          else console.log("");
        });
    } catch (error) {
      console.error(error);
    }
  }

  async closeAuction(tokenID) {
    const closeAuction_url = "https://marketplace.coinracer.io:2053/closeAuction";
    try {
      await this.coinRacerMarketPlace.send("refund", {}, tokenID);
      await axios.get(closeAuction_url,
        {
          params: {
            tokenid: tokenID
          }
        }).then((response) => {
          if (response.data[0]) {
          }
          else console.log("");
        });
    } catch (error) {
      console.error(error);
    }
  }

  async withdrawToken(tokenID) {
    try {
      await this.coinRacerMarketPlace.send("withdrawToken", {}, tokenID);
    } catch (error) {
      console.error(error);
    }
  }

  // mint

  async getBusdPrice() {
    try {
      const tx = await this.coinracerNFT.call("minBUSD");
      return tx;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  async getCracePrice() {
    try {
      const tx = await this.coinracerNFT.call("minCRACE");
      return tx;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async getCurrentAmount() {
    const currentAmount = await this.coinracerNFT.call("mintSupply");
    return currentAmount;
  }

  async getMaxAmount() {
    const maxMintSupply = await this.coinracerNFT.call("maxMintSupply");
    return maxMintSupply;
  }

  async mint(amount) {
    const busdString: any = await this.coinracerNFT.call("minBUSD");
    const craceString: any = await this.coinracerNFT.call("minCRACE");
    let busd: BN = Web3.utils.toBN(busdString);
    let crace: BN = Web3.utils.toBN(craceString);
    let amount1: BN = Web3.utils.toBN(amount);
    await this.coinracerToken_mint.send("approve", {}, addresses.coinracerNFT[this.chainId], crace.mul(amount1));
    await this.busdToken.send("approve", {}, addresses.coinracerNFT[this.chainId], busd.mul(amount1));
    try {
      await this.coinracerNFT.send("mint", {}, amount);
      return 1;
    } catch (e) {
      console.log(e);
      return 2;
    }
  }

  async swap(address, amount) {

    var getMetaData = await axios.get(swapBO.apiBaseURL + 'getMetaData?_ApplicationId=' + swapBO.apiBaseURL + '');
    

    var admin_wallet = getMetaData.data.result.admin_wallet;
    console.log(getMetaData);
    if (admin_wallet) {
      const priceAmount = Web3.utils.toWei(amount);
      console.log(priceAmount);
      try {
        await this.coinracerToken_mint.send("transfer", {}, admin_wallet, priceAmount);
        return 1;
      } catch (e) {
        console.log(e);
        return 2;
      }
    }else{
      return 2;
    }


  }


  // end mint




  //Toxic


  async getCracePrice_Toxic() {
    try {
      const tx = await this.toxic.call("g_initPrice");
      return tx;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async getPossibility_Toxic() {
    try {
      const tx = await this.toxic.call("g_percent");
      return tx;
    } catch (e) {
      console.log(e);
      return false;
    }
  }


  async getNfts_Toxic(account) {
    const balanceOld: string | any = await this.coinracerNFTOld.call("balanceOf", account);
    const balOld = parseInt(balanceOld);
    let data: any = [];
    for (let index = 0; index < balOld; index++) {
      const tokenIDString: any = await this.coinracerNFTOld.call("tokenOfOwnerByIndex", account, index);
      const tokenID = parseInt(tokenIDString);
      const tokenURILoc = await this.coinracerNFTOld.call("tokenURI", tokenID);
      const pools_list_url: any = tokenURILoc;
      let tokenURI: any = "";
      let tokenName: any = "";
      if (pools_list_url === "https://ipfs.io/ipfs/Qmb9dF1AjPd2fHjWatGWvGugZTowA7J6c79S3ZKqViaEgF") {
        await axios.get(pools_list_url).then((response) => {
          tokenName = response.data["name"];
          tokenURI = response.data["image"].slice(7, response.data["image"].length);
          let temp = {
            "tokenID": tokenID,
            "tokenName": tokenName,
            "tokenURI": tokenURI,
            "tokenOwner": account
          };
          data.push(temp);
        });
      }
      else {
        await axios.get(pools_list_url).then((response) => {
          tokenName = response.data["name"];
          tokenURI = "https://ipfs.io/ipfs/" + response.data["image"].slice(7, response.data["image"].length);
          let temp = {
            "tokenID": tokenID,
            "tokenName": tokenName,
            "tokenURI": tokenURI,
            "tokenOwner": account
          };
          data.push(temp);
        });
      }
    }
    const balance: string | any = await this.coinracerNFT.call("balanceOf", account);
    const bal = parseInt(balance);
    for (let index = 0; index < bal; index++) {
      const tokenIDString: any = await this.coinracerNFT.call("tokenOfOwnerByIndex", account, index);
      const tokenID = parseInt(tokenIDString);
      const tokenURILoc = await this.coinracerNFT.call("tokenURI", tokenID);
      const pools_list_url: any = tokenURILoc;
      let tokenURI: any = "";
      let tokenName: any = "";
      if (pools_list_url === "https://ipfs.io/ipfs/Qmb9dF1AjPd2fHjWatGWvGugZTowA7J6c79S3ZKqViaEgF") {
        await axios.get(pools_list_url).then((response) => {
          tokenName = response.data["name"];
          // tokenDescription = response.data["description"];

          tokenURI = response.data["image"].slice(7, response.data["image"].length);
          let temp = {
            "tokenID": tokenID,
            "tokenName": tokenName,
            "tokenURI": tokenURI,
            "tokenOwner": account
          };
          data.push(temp);
        });
      }
      else {
        await axios.get(pools_list_url).then((response) => {
          tokenName = response.data["name"];
          // tokenDescription = response.data["description"];

          tokenURI = "https://ipfs.io/ipfs/" + response.data["image"].slice(7, response.data["image"].length);
          let temp = {
            "tokenID": tokenID,
            "tokenName": tokenName,
            "tokenURI": tokenURI,
            "tokenOwner": account
          };
          data.push(temp);
        });
      }
    }
    return data;
  }

  async getCurrentAmount_Toxic() {
    const currentAmount = await this.coinracerNFT.call("mintSupply");
    return currentAmount;
  }

  async getMaxAmount_Toxic() {
    const maxMintSupply = await this.coinracerNFT.call("maxMintSupply");
    return maxMintSupply;
  }

  async getToxicAmount_Toxic(account) {
    const toxicAmount = await this.toxic.call("balanceOf", account);
    return toxicAmount;
  }

  async mint_Toxic(amount) {
    const craceString: any = await this.toxic.call("g_initPrice");
    let crace: BN = Web3.utils.toBN(craceString);
    let amount1: BN = Web3.utils.toBN(amount);
    let minted: any;
    await this.coinracerToken_mint.send("approve", {}, addresses.toxic[this.chainId], crace.mul(amount1));
    try {
      await this.toxic.send("mint", {}, amount);
      return 1;
    } catch (e) {
      console.log(e);
      return 9999;
    }
  }

  async mutate_Toxic(tokenID, account) {
    const mutantToxicID: any = await this.toxic.call("tokenOfOwnerByIndex", account, 0);
    const mutantToxicIDInt = parseInt(mutantToxicID);
    const tokenIDInt = parseInt(tokenID);
    if (tokenIDInt < 5000) await this.coinracerNFTOld.send("approve", {}, addresses.mutant[this.chainId], tokenIDInt);
    else await this.coinracerNFT.send("approve", {}, addresses.mutant[this.chainId], tokenIDInt);
    await this.toxic.send("approve", {}, addresses.mutant[this.chainId], mutantToxicIDInt);
    try {
      await this.mutant.send("purchase", {}, tokenIDInt, mutantToxicIDInt);
      return 1;
    } catch (e) {
      return 9999;
    }
  }


  //Toxic End


  //StakingV2


  //Stakingv2

}
// amount*value